import React from "react";
import { observer, inject } from "mobx-react";

import { Link, withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { ComparePopUp } from "ComponentsUI/SideWidgets";
import { CompareSlider } from "ComponentsUI/Sliders";
import { generateUrl } from "Services/withDefaultParams";
import Button from "ComponentsUI/Button";
import * as Routes from "Configs/routes";

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class CompareTariffsContainer extends React.Component {
	onCompareHandler() {
		let {
			ApplicationModel: { compareTarifficationsModel },
			location,
		} = this.props;
		compareTarifficationsModel.setRefererUrl(location.pathname);
	}

	componentDidMount() {
		let model = this.props.ApplicationModel.compareTarifficationsModel;
		model.loadFromStorage();
	}

	render() {
		let model = this.props.ApplicationModel.compareTarifficationsModel;

		if (model.widgetIsHide) {
			return null;
		}

		let textConfig = this.props.ApplicationModel.text;
		let compareUrl =
			model.getTariffs().length >= 2
				? generateUrl(Routes.Compare.route, {
						regionUrl: this.props.match.params.regionUrl,
					})
				: "http://www.google.com";

		let button = (
			<Button
				typeText="small"
				size="middle"
				component={<Link to={!!compareUrl ? compareUrl : "/"} />}
				fullWidth={true}
				datatest="main_compare_button"
				withoutPaddings={true}
				status="secondaryAccent"
				onClick={() => {
					model.closeCompare();
				}}
			>
				<span>{textConfig.COMPARE_TARIFFS}</span>
			</Button>
		);

		let sliderComponent = (
			<CompareSlider
				text={textConfig}
				tariffs={model.getTariffs()}
				compareButton={button}
				removeTariff={(tariff) => {
					model.removeTariff(tariff);
				}}
			/>
		);

		return (
			<ComparePopUp
				isOpen={model.isOpen}
				tariffs={model.getTariffs()}
				closeWindow={() => {
					model.closeCompare();
				}}
				showWindow={() => {
					model.openCompare();
				}}
				onCompareClick={() => this.onCompareHandler()}
				sliderComponent={sliderComponent}
			/>
		);
	}
}
